module.exports = __webpack_public_path__ + "er.svg?8d5171c77e388034f48931bb77b65014";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/er.svg
// module id = 1343
// module chunks = 0